import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home'
import Login from './views/Login'
import Test1 from './test/Test1'
import AlarmRuleManage from './views/setting/alarmRuleManage/AlarmRuleManage'
import AddAlarmRule from './views/setting/alarmRuleManage/AddAlarmRule'
import DatabaseBackup from './views/System/databaseBackup/DatabaseBackup'
import UserManage from './views/System/user/UserManage'
import DataUpdate from './views/setting/dataUpdate/DataUpdate'
import AreaSetting from './views/setting/areaSetting/AreaSetting'
import SystemUpdate from './views/System/Update/SystemUpdate'
import ChartsAnalyse from './views/homes/ChartsAnalyse'
import AlarmPointHome from './views/alarmPoint/alarmView/AlarmPointHome'
import AlarmStatistic from './views/alarmManage/alarmStatistic/AlarmStatistic'
import AlarmInspectRecord from './views/alarmPoint/alarmView/alarmPointInfo/HistoryRecord/AlarmInspectRecord/AlarmInspectRecord'
import AlarmReportRecord from './views/alarmPoint/alarmView/alarmPointInfo/HistoryRecord/AlarmReportRecord/AlarmReportRecord'
import AlarmUpdateRecord from './views/alarmPoint/alarmView/alarmPointInfo/HistoryRecord/AlarmUpdateRecord/AlarmUpdateRecord'
import AlartRecord from './views/alarmPoint/alarmView/alarmPointInfo/HistoryRecord/AlartRecord'
import StaticInformationRecordList
  from './views/alarmPoint/alarmView/alarmPointInfo/HistoryRecord/StaticInformationRecordList'
import IndexVideo from './views/IndexVideo/IndexVideo'
import ElTableTest from './test/ElTableTest'
import Erweima from './views/Erweima'
// import QRCode from './views/alarmPoint/alarmView/alarmPointInfo/QRCode/QRCode'
Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/alarmPointHome',
      redirect: '/alarmPointView'
    },
    {
      path: '/alarmPointHome',
      name: 'alarmPointHome',
      component: AlarmPointHome,
      children: [
        {
          path: '/staticInformationRecordList',
          component: resolve => require(['./views/alarmPoint/alarmView/alarmPointInfo/HistoryRecord/StaticInformationRecordList'],resolve),
          meta: {title: '静态信息修改记录'}
        },
        {
          path:'/alarmPointView',
          component: resolve => require(['./views/alarmPoint/alarmView/alarmPointInfo/AlarmPointView'],resolve),
          meta: { title: '警报点详细信息'}
        },
        {
          path: '/alarmControllerView',
          component: resolve => require(['./views/alarmPoint/alarmView/alarmPointInfo/AlarmControllerView'],resolve),
          meta: { title:'警报点控制器信息'},
        },
        {
          path: '/alarmView',
          component: resolve => require(['./views/alarmPoint/alarmView/alarmPointInfo/AlarmView'],resolve),
          meta: { title: '报警器信息'}
        },
        {
          path: '/iotterminal',
          component: resolve => require(['./views/alarmPoint/alarmView/alarmPointInfo/IOTTerminal'], resolve),
          meta: { title:'物联网监测终端' },
        },
        {
          path: '/realTimeData',
          component: resolve => require(['./views/alarmPoint/alarmView/alarmPointInfo/dynamicData/RealTimeData'], resolve),
          meta: { title: '实时数据' }
        },
        {
          path: '/historyData',
          component: resolve => require(['./views/alarmPoint/alarmView/alarmPointInfo/dynamicData/HistoryData'], resolve),
          meta: { title: '历史数据' }
        },
        {
          path: '/alarmPointTotalInfo',
          component: resolve => require(['./views/alarmPoint/alarmView/alarmPointInfo/AlarmPointTotalInfo'], resolve),
          meta: { title: '警报点信息'}
        },
        {
          path: '/alarmInspectRecord',
          component: resolve => require(['./views/alarmPoint/alarmView/alarmPointInfo/HistoryRecord/AlarmInspectRecord/AlarmInspectRecord'], resolve),
          meta: { title: '巡检记录' }
        },
        {
          path: '/alarmReportRecord',
          component: resolve => require(['./views/alarmPoint/alarmView/alarmPointInfo/HistoryRecord/AlarmReportRecord/AlarmReportRecord'], resolve),
          meta: { title: '报修记录' }
        },
        {
          path: '/alarmRepairRecord',
          component: resolve => require(['./views/alarmPoint/alarmView/alarmPointInfo/HistoryRecord/AlarmRepairRecord/AlarmRepairRecord'], resolve),
          meta: { title: '维修记录' }
        },
        {
          path: '/alarmUpdateRecord',
          component: resolve => require(['./views/alarmPoint/alarmView/alarmPointInfo/HistoryRecord/AlarmUpdateRecord/AlarmUpdateRecord'], resolve),
          meta: { title: '升级记录' }
        },
        {
          path: '/alartRecord',
          component: resolve => require(['./views/alarmPoint/alarmView/alarmPointInfo/HistoryRecord/AlartRecord'], resolve),
          meta: { title:"告警记录" }
        },
        {
          path: '/monitor',
          component: resolve => require(['./views/alarmPoint/alarmView/alarmPointInfo/monitor/Monitor3'], resolve),
          meta: {title: "监控"}
        },
        {
          path: '/monitor-outdoor',
          component: resolve => require(['./views/alarmPoint/alarmView/alarmPointInfo/monitor/monitor-outdoor'], resolve),
          meta: {title: "实时回放-户外"}
        },
        {
          path: '/videoPlayback',
          component: resolve => require(['./views/alarmPoint/alarmView/alarmPointInfo/monitor/videoPlayBack'], resolve),
          meta: {title: "录像回放"}
        },
        {
          path: '/videoPlayback-outdoor',
          component: resolve => require(['./views/alarmPoint/alarmView/alarmPointInfo/monitor/videoPlayBack-outdoor'], resolve),
          meta: {title: "录像回放"}
        },
        {
          path: '/qrcode',
          component: resolve => require(['./views/alarmPoint/alarmView/alarmPointInfo/QRCode/QRCode'], resolve),
          meta: {title: "二维码"}
        },
        {
          path: '/hardwareInfo',
          component: resolve => require(['./views/alarmPoint/alarmView/alarmPointInfo/hardwareInfo/hardwareInfo'], resolve),
          meta: {title: "硬件信息"}
        }
      ]
    },
    {
      path: '/home',
      redirect: '/map'
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      children:[
        {
          path:'/alarmPointView',
          component: resolve => require(['./views/alarmPoint/alarmView/alarmPointInfo/AlarmPointView'],resolve),
          meta: { title: '警报点详细信息',requireAuth: true,}
        },
        {
          path: '/bigScreen',
          component: resolve => require(['./views/homes/BigScreen'], resolve),
          meta: { title: '运维大屏',requireAuth: true,  }
        },
        {
          path: '/bigScreen2',
          component: resolve => require(['./views/homes/BigScreen2'], resolve),
          meta: { title: '监测大屏',requireAuth: true,  }
        },
        {
          path: '/map',
          component: resolve => require(['./views/homes/CityMap'], resolve),
          meta: { title: '总体态势',requireAuth: true,  }
        },
        {
          path: '/chartsAnalyse',
          component: resolve => require(['./views/homes/ChartsAnalyse'], resolve),
          meta: { title: '统计分析',requireAuth: true,  },
        },
        {
          path: '/realTimeMonitoring',
          component: resolve => require(['./views/homes/realTimeMonitoring'], resolve),
          meta: { title: '实时监控',requireAuth: true,  },
        },
        {
          path: '/alarmPointManage',
          component: resolve => require(['./views/alarmPoint/AlarmPointManage'], resolve),
          meta: { title: '警报点管理',requireAuth: true,  },
        },
        {
          path: '/alarmManage',
          component: resolve => require(['./views/alarmManage/alarmManage/AlarmManage'], resolve),
          meta: { title: '告警记录',requireAuth: true, }
        },
        {
          path: '/ringingState',
          component: resolve => require(['./views/alarmManage/alarmManage/ringingState'], resolve),
          meta: { title: '鸣响状态',requireAuth: true, }
        },
        // {
        //   path: '/alarmStatistic',
        //   component: resolve => require(['./views/alarmManage/alarmStatistic/AlarmStatistic'], resolve),
        //   meta: { title: '告警分析' }
        // },
        {
          path: '/alarmRuleManage',
          component: resolve => require(['./views/setting/alarmRuleManage/AlarmRuleManage'], resolve),
          meta: { title: '告警规则管理',requireAuth: true, }
        },
        {
          path: '/addAlarmRule',
          component:resolve => require(['./views/setting/alarmRuleManage/AddAlarmRule'], resolve),
          meta: { title: '添加告警规则',requireAuth: true, }
        },
        {
          path: '/stateManagement',
          component:resolve => require(['./views/stateManagement/stateManagement'],resolve),
          meta:{title:'状态管理',requireAuth: true, }
        },
        {
          path: '/inspectionCycle',
          component: resolve => require(['./views/InspectAndRepair/inspectionCycle/InspectionCycle'],resolve),
          meta:{title: '巡检任务规划',requireAuth: true, }

        },
        {
          path: '/inspectionCycle1',
          component: resolve => require(['./views/InspectAndRepair/inspectionCycle/InspectionCycle'],resolve),
          meta:{title: '巡检任务规划1',requireAuth: true, }

        },
        {
          path: '/inspectTaskAssignment',
          component: resolve => require(['./views/InspectAndRepair/taskAssignment/inspectTaskAssignment'],resolve),
          meta:{title: '巡检任务分配',requireAuth: true, }

        },
        {
          path: '/repairTaskAssignment',
          component: resolve => require(['./views/InspectAndRepair/taskAssignment/repairTaskAssignment'],resolve),
          meta:{title: '维修任务分配',requireAuth: true, }

        },
        {
          path: '/taskConfirm',
          component: resolve => require(['./views/InspectAndRepair/taskAssignment/taskConfirm'],resolve),
          meta:{title: '任务确认',requireAuth: true,}

        },
        {
          path: '/inspectRecord',
          component: resolve => require(['./views/InspectAndRepair/InspectRecord/InspectRecord'], resolve),
          meta: { title: '巡检记录',requireAuth: true, }
        },
        {
          path: '/updateRecord',
          component: resolve => require(['./views/InspectAndRepair/UpdateRecord/UpdateRecord'], resolve),
          meta: { title: '升级记录',requireAuth: true,  }
        },
        {
          path: '/reportRecord',
          component: resolve => require(['./views/InspectAndRepair/ReportRecord/ReportRecord'], resolve),
          meta: { title: '报修记录',requireAuth: true, }
        },
        {
          path: '/repairRecord',
          component: resolve => require(['./views/InspectAndRepair/RepairRecord/RepairRecord'], resolve),
          meta: { title: '维修记录',requireAuth: true,  }
        },
        {
          path: '/databaseBackup',
          component: resolve => require(['./views/System/databaseBackup/DatabaseBackup'], resolve),
          meta: { title: '数据库备份',requireAuth: true, }
        },
        {
          path: '/systemUpdate',
          component: resolve => require(['./views/System/Update/SystemUpdate'], resolve),
          meta: { title: '系统更新',requireAuth: true, }
        },
        {
          path: '/userManage',
          component: resolve => require(['./views/System/user/UserManage'], resolve),
          meta: { title: '账户管理',requireAuth: true, }
        },
        {
          path: '/dataUpdate',
          component: resolve => require(['./views/setting/dataUpdate/DataUpdate'], resolve),
          meta: { title: '数据更新',requireAuth: true,  }
        },
        {
          path: '/areaSetting',
          component: resolve => require(['./views/setting/areaSetting/AreaSetting'], resolve),
          meta: { title: '区域设置',requireAuth: true,  }
        },
        {
          path: '/sensorSetting',
          component: resolve => require(['./views/setting/sensorSetting/SensorSetting'], resolve),
          meta: { title: '传感器设置',requireAuth: true,  }
        },
        {
          path: '/cameraSetting',
          component: resolve => require(['./views/setting/cameraSetting/CameraSetting'], resolve),
          meta: { title: '摄像头设置',requireAuth: true,  }
        },
        {
          path: '/portSetting',
          component: resolve => require(['./views/setting/portSetting/PortSetting'], resolve),
          meta: { title: '串口设置',requireAuth: true,  }
        },
        {
          path: '/sendRecord',
          component: resolve => require(['./views/alarmRecord/SendRecord'], resolve),
          meta: { title: '发送记录',requireAuth: true,  }
        },
        {
          path: '/returnRecord',
          component: resolve => require(['./views/alarmRecord/ReturnRecord'], resolve),
          meta: { title: '回示记录',requireAuth: true,  }
        },
        {
          path: '/videoTest',
          component: resolve => require(['./views/IndexVideo/IndexVideo'], resolve),
          meta: { title: 'canvas测试',requireAuth: true,  }
        },
        // {
        //   path: '/MapTest',
        //   component: resolve => require(['./views/setting/MapTest'], resolve),
        //   meta: { title: '地图测试',requireAuth: true,  }
        // },
        {
          path: '/elTableTest',
          component: ElTableTest,
          meta: { title: 'el-table测试',requireAuth: true, }
        },

      ]
    },


  ]
})
